// Detects a new deployment (backend build marker changed) and force-reloads once,
// so the browser can't keep serving a stale bundle after a deploy.
const KEY = "app_build_marker";

export async function checkBuildVersion() {
  try {
    const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/version`, { cache: "no-store" });
    if (!res.ok) return;
    const { build } = await res.json();
    if (!build) return;
    const previous = localStorage.getItem(KEY);
    localStorage.setItem(KEY, build);
    if (previous && previous !== build) {
      if (window.caches?.keys) {
        const keys = await window.caches.keys();
        await Promise.all(keys.map((k) => window.caches.delete(k)));
      }
      window.location.reload();
    }
  } catch {
    // offline or older backend without /api/version — ignore
  }
}
